import React, { useState, useEffect } from "react";
import { useForm, FormProvider, Controller, get } from "react-hook-form";
import { Steps, StepsProvider, useSteps } from "react-step-builder";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { DropzoneDialog } from "material-ui-dropzone";
import { MaterialUIDatePickers } from "./../../stories/hook-controls/datepicker/datepicker";
//Component
import { Modal } from "../../stories/modalSchedule";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
//Function
import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { formatDateTime } from "../../utils/common-function"
import { TextField, Divider } from "@material-ui/core";
import * as api from "./api";
import * as common from "../../utils/common-function";
import * as alertDialog from "../../utils/alert";
import { set } from "date-fns";


const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(1),
        // marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginLeft: 5,
        minWidth: 90,
    },
    textLabelRight: {
        margin: theme.spacing(1),
        minWidth: 180,
        textAlign: "left",
        align: "right",
    },
    checkWeekly: {
        margin: theme.spacing(1),
        minWidth: 80,
    },
    labelInput: {
        margin: theme.spacing(1),
        minWidth: 170,
    },
    labelInputRadio: {
        marginTop: theme.spacing(-1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
        minWidth: 170,
    },
    labelInputCheckBox: {
        // marginTop: theme.spacing(-1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        minWidth: 180,
    },
    textInput: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(1),
    },
    labelDate: {
        marginTop: theme.spacing(0),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
        minWidth: 120,
    },
    alignConnect: {
        margin: 'auto',
        align: "center",
        //padding: theme.spacing(2),
        textAlign: 'left',
    },
    textLabel: {
        color: '#000'
    },
    textLabelHelper: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    textOutputHelper: {
        //marginTop: theme.spacing(1),
        //marginLeft: theme.spacing(),
    },
    textXS12: {
        marginLeft: theme.spacing(1),
    },
    textXS12Mail: {
        marginLeft: -3,
    },
    textField: {
        height: 10,
    },
    textLabelCountLength: {
        marginLeft: theme.spacing(1),
        marginTop: '-2px',
    }
}));

function AddJobSchedule(props) {
    const classes = useStyles();
    const { open } = props;
    const { ...otherprops } = props;
    const [step, setStep] = useState(0);
    const method = useForm();
    const { register, getValues } = method;
    const { setValue, setError, clearErrors, errors, control } = method;
    const [lstInitScreen, setlstInitScreen] = useState([]);
    const [typeRunJob, settypeRunJob] = useState(1);
    const [hiddenWeekly, sethiddenWeekly] = useState(true);
    const [hiddenMonthly, sethiddenMonthly] = useState(true);
    const [hiddenUpfile, setHiddenUpfile] = useState(false);
    const [hiddenFreeText, setHiddenFreeText] = useState(true);
    const [hiddenInputMail, setHiddenInputMail] = useState(true);
    const [state, setState] = useState({
        checkedNotiEmail: false,
        MONTHLY_DATE_END: false
    });
    const [typeInputSql, settypeInputSql] = useState('TextFile');
    const [typeOutput, settypeOutput] = useState('');
    const [openUpload, setOpenUpload] = useState(false);
    const [file, setfile] = useState([]);
    const [sqlText, setSqlText] = useState('');
    const [jobName, setJobName] = useState('');
    const [hourTime, setHourTime] = useState('');
    const [minuteTime, setMinuteTime] = useState('');
    const [emailList, setEmailList] = useState('');
    const [listWeekly, setlistWeekly] = useState([]);
    const [listMonthly, setlistMonthly] = useState([]);
    const [dayMonth, setDayMonth] = useState('');
    const [ConnectInfo, setConnectInfo] = useState([]);
    const [startDate, setStartDate] = useState(common.formatDate(new Date()));
    const [endDate, setEndDate] = useState(common.formatDate(new Date()));
    const [initDate, setInitDate] = useState(1);
    const [countLength, setCountLength] = useState(0);
    // const [userName, setUserName] = useState('');
    // const [passWord, setPassword] = useState('');
    const [userDB, setUserDB] = useState('');
    const [passDB, setPassDB] = useState('');
    const [listDisableTime, setListDisableTime] = useState([]);
    const hiddenFileInput = React.useRef(null);
    const limitLengthSql = 2097152;
    const limitLengthSqlText = 2000000;
    const txtErrorLength = "Input text size cannot exceed more than 2MB";
    const txtEndOfmonth = "End of Month";
    const [hostKey, setHostKey] = useState('');
    const [hostTitle, setHostTitle] = useState('');
    const [hostName, setHostName] = useState('');
    const [dbName, setDBName] = useState('');
    const [dbPort, setDBPort] = useState('');
    const [backUpServer, setBackUpServer] = useState('');

    const resetAllState = () => {
        sethiddenWeekly(true);
        sethiddenMonthly(true);
        setHiddenUpfile(false);
        setHiddenFreeText(true);
        setHiddenInputMail(true);
        setSqlText('');
        setHourTime('');
        setMinuteTime('');
        setEmailList('');
        setlistWeekly([]);
        setlistMonthly([]);
        setDayMonth('');
        setInitDate(1);
        setListDisableTime([]);
        settypeInputSql('TextFile');
        settypeOutput('');
        setOpenUpload(false);
        setStartDate(common.formatDate(addDays(new Date(), 1)));
        setEndDate(common.formatDate(addDays(new Date(), 1)));
        setfile([]);
        setJobName('');
        settypeRunJob(1);
        setlstInitScreen([]);
        setDBName('');
        setHostTitle('');
        setBackUpServer('');
        setState({
            checkedNotiEmail: false,
            MONTHLY_DATE_END: false
        })
    }
    useEffect(() => {
        setValue("FILE_NAME", file?.path);
    }, [file, setValue]);
    async function upload(files = []) {
        setfile(files[0]);
        handleFileUpload(files[0]);
    }
    const handleFileUpload = (files) => {
        if (!files) return null;
        const reader = new FileReader();
        reader.onload = (evt) => {
            //console.log(evt.target.result);
            setSqlText(evt.target.result);
        };
        reader.readAsBinaryString(files);
    }
    const handleChangeHostName = (event) => {
        const getDBInfo = lstInitScreen?.ListDataBase?.filter(x =>
            x.HOST_KEY === event.target.value
        );
        console.log(event.target);
        console.log(getDBInfo);
        setHostKey(getDBInfo[0]?.HOST_KEY);
        setHostName(getDBInfo[0]?.HOST_NAME);
        setDBName(getDBInfo[0]?.DATABASE_NAME);
        setDBPort(getDBInfo[0]?.PORT);
        setBackUpServer(getDBInfo[0]?.BACKUP_SERVER);
        setHostTitle(getDBInfo[0]?.HOST_TITLE);
    };
    const onSQLChange = async (event) => {
        //console.log(event.target.value.length);
        document.getElementById("countLenght").innerHTML = genDivCountSql(event.target.value.length);
        //setCountLength(event.target.value.length);
        if (event.target.value.length >= limitLengthSql) { //2,097,152 bytes
            alertDialog.ErrorDialog(txtErrorLength);
            event.preventDefault();
            return;
        }
    }
    const genDivCountSql = (lengthText) => {
        return lengthText + " / " + limitLengthSqlText;
    }

    const onFileChange = async (event) => {
        console.log(event.target.files[0]);
        const fileData = event.target.files[0];
        setStateScreen();
        if (fileData === undefined)
            return;
        if (fileData?.size > 2097152) { //2,097,152 bytes
            alertDialog.ErrorDialog("File size cannot exceed more than 2MB");
            setfile([]);
            setSqlText("");
            return;
        }
        if (fileData?.type === 'text/plain' || (fileData?.type === '' && fileData?.name.endsWith(".sql"))) { //16777216
            setfile(event.target.files[0]);
            handleFileUpload(event.target.files[0]);
        }
        else {
            alertDialog.ErrorDialog("File type not allow. Please input sql or text file");
            setfile([]);
            setSqlText("");
            return;
        }


        // Update the state
        //this.setState({ selectedFile: event.target.files[0] });

    };
    const resetDisable = () => {
        setHourTime('');
        setMinuteTime('');
        setListDisableTime([]);
    }
    const handleChange = (event) => {
        settypeRunJob(event.target.value);
        setStateScreen();
        if (event.target.value === 3) {
            sethiddenWeekly(true);
            sethiddenMonthly(false);
        } else if (event.target.value === 2) {
            sethiddenWeekly(false);
            sethiddenMonthly(true);
        } else {
            sethiddenWeekly(true);
            sethiddenMonthly(true);
        }
        resetDisable();
        CheckSlotAvailable(getSchedule(), hourTime, minuteTime, event.target.value);//        dateSelect, hour, minute, typesched
        fetchNotAvalible(getSchedule(), hourTime, event.target.value);
    };
    const onInputJobChange = async (event) => {
        let valid = common.validateNotSpecialCharacter(event.target.value);
        if (!valid) { //check
            alertDialog.ErrorDialog("Job name not have special character.");
            return;
        }

    }
    const onCheckDulplicate = async (event) => {
        //console.log(event.target.value);
        if (event.target.value === "") {
            return;
        }
        let param = { "JOB_NAME": event.target.value };
        let res = await api.CheckJobNameDulpicate(param);
        if (res?.ResultCode === 20) {
            alertDialog.ErrorDialog(res?.Message);
            return;
        }
    }
    const handleChangeHour = (event) => {
        //console.log(typeRunJob);
        setHourTime(event.target.value);
        setMinuteTime('');
        setStateScreen();
        CheckSlotAvailable(getSchedule(), event.target.value, minuteTime, typeRunJob);//        dateSelect, hour, minute, typesched
        fetchNotAvalible(getSchedule(), event.target.value, typeRunJob);
    };
    const handleChangeMinute = (event) => {
        setMinuteTime(event.target.value);
        setStateScreen();
        CheckSlotAvailable(getSchedule(), hourTime, event.target.value, typeRunJob);//        dateSelect, hour, minute, typesched
    };

    const handleChangeWeekly = (event) => {
        resetDisable();
        setlistWeekly(getValues().WEEKLY_DATE);
        CheckSlotAvailable(getValues().WEEKLY_DATE.join(','), hourTime, minuteTime, typeRunJob);//        dateSelect, hour, minute, typesched
        fetchNotAvalible(getValues().WEEKLY_DATE.join(','), hourTime, typeRunJob);
    };
    // const handleChangeMonthly = (event) => {
    //     resetDisable();
    //     setlistMonthly(getValues().MONTHLY_DATE);
    //     CheckSlotAvailable(getValues().MONTHLY_DATE.join(','), hourTime, minuteTime, typeRunJob);//        dateSelect, hour, minute, typesched
    //     fetchNotAvalible(getValues().MONTHLY_DATE.join(','), hourTime, typeRunJob);
    //     //setStatScreen();
    //     ////console.log(event.target.value);
    //     //setState({ ...state, [event.target.name]: event.target.value });
    // };
    const handleChangeMonthly = (day) => {

        resetDisable();
        let daySelect = day.target.value;
        //console.log(daySelect);
        setDayMonth(daySelect);
        CheckSlotAvailable(daySelect, hourTime, minuteTime, typeRunJob);//        dateSelect, hour, minute, typesched
        fetchNotAvalible(daySelect, hourTime, typeRunJob);
    };
    const handleChangeStartDate = (date) => {
        setInitDate(0);
        setStartDate(date);
        setEndDate(addDays(date, lstInitScreen?.Effective_End ?? 0));
        setStateScreen();
    }
    const handleChangeEndDate = (date) => {
        setInitDate(0);
        setEndDate(date);
        setStateScreen();
    }

    const handleChangeTypeSql = (event) => {
        settypeInputSql(event.target.value);
        setStateScreen();
        if (event.target.value === 'FreeText') {
            setHiddenFreeText(false);
            setHiddenUpfile(true);
            setSqlText("");
            setfile([]);
        } else {
            setHiddenFreeText(true);
            setHiddenUpfile(false);
            setSqlText("");
            setfile([]);
        }
    }
    const handleChangeOutputType = (event) => {
        if (event.target.value === typeOutput) {
            settypeOutput("");
        } else {
            settypeOutput(event.target.value);
        }
        setStateScreen();
    }

    const openModalUpload = (e) => {
        setOpenUpload(true);
        setStateScreen();
    }

    const handleChangeNotiMail = (event) => {
        //console.log(event.target.name);
        //console.log(event.target.checked);
        setStateScreen();
        setState({ ...state, [event.target.name]: event.target.checked });
        if (event.target.checked) {
            setHiddenInputMail(false);
            if (emailList === '') {
                setEmailList(lstInitScreen?.EMAIL);
            }
        } else {
            setHiddenInputMail(true);
        }

    }
    const handleChangeEndOFMonthly = (event) => {
        setStateScreen();
        setState({ ...state, [event.target.name]: event.target.checked });
    }

    useEffect(() => {
        if (!open) return;
        resetAllState();
        fetch();
    }, [setValue, open]);

    const fetch = async () => {
        let res = await api.getInitScreen();
        console.log(res);
        setlstInitScreen(res);
        setHostKey(res.DBInformation.hostKey);
        setHostName(res.DBInformation.hostName);
        setDBPort(res.DBInformation.dbPort);
    };

    const fetchNotAvalible = async (dateSelect, hour, typesched) => {
        if (hour === '') {
            return;
        }
        //console.log(dateSelect);
        if (typesched !== 1 && (dateSelect === '' || dateSelect === null)) {
            return;
        }
        let param = {
            Schedule_Type: typesched,
            Hour: hour,
            ScheduleDate: dateSelect
        };
        let res = await api.GetNotAvalableTime(param);
        setListDisableTime(res);

    };
    const addDays = (date, number) => {
        const newDate = new Date(date);
        return new Date(newDate.setDate(newDate.getDate() + number));
    }

    const ClearError = async (e) => {
        clearErrors(e.target.name);
    };

    const CheckSlotAvailable = async (dateSelect, hour, minute, typesched) => {
        if (hour === '' || minute === '') {
            return;
        }
        //console.log(dateSelect);
        if (typesched !== 1 && (dateSelect === '' || dateSelect === null)) {
            return;
        }

        let param = {
            Schedule_Type: typesched,
            Hour: hour,
            Minute: minute,
            ScheduleDate: dateSelect
        };

        let res = await api.CheckSlotJobAvailable(param);
        if (res.ResultCode === 20) { //
            alertDialog.ErrorDialog(res?.Message);
            return;
        }
    };


    const getSchedule = () => {
        if (typeRunJob === 2) {
            return listWeekly.join(',');
        } else if (typeRunJob === 3) {
            return dayMonth;
        }
        else {
            return null;
        }
    }
    const SaveJob = async () => {
        if (getValues().UserName.trim() === '') { //check choose userName
            alertDialog.ErrorDialog("Please input username");
            return;
        }
        if (getValues().Password.trim() === '') { //check choose password
            alertDialog.ErrorDialog("Please input password.");
            return;
        }
        setUserDB(getValues().UserName.trim());
        setPassDB(getValues().Password.trim());
        let param = {
            hostName: hostName,
            userName: getValues().UserName.trim(),
            passWord: getValues().Password.trim(),
            dataBase: getValues().Database.trim(),
            hostKey: hostKey,
            hostTitle: hostTitle,
            port: dbPort,
            jobName: jobName,
            scheduleType: typeRunJob,
            scheduleDate: getSchedule(),
            scheduleHour: hourTime,
            scheduleTime: minuteTime,
            startDate: startDate,
            endDate: initDate === 1 ? addDays(endDate, lstInitScreen?.Effective_End ?? 0) : endDate,
            sqlScript: sqlText,
            outPutType: typeOutput,
            notiEmail: state.checkedNotiEmail,
            listEmail: emailList,
            endOfMonth: state.MONTHLY_DATE_END,

        };
        let res = await api.SaveJobSchedule(param);
        if (res.ResultCode === 10) { //Success
            alertDialog.SuccessShowButtonCloseModal("You Job Schedule setting completed.", props);
        }
        if (res.ResultCode === 20) {
            alertDialog.ErrorDialog(res?.Message);
            setStep(0);
            return;
        }
        if (res.ResultCode === 30) {
            alertDialog.ErrorDialog(res?.Message);
            //setStep(0);
            return;
        }
    }
    const SaveJobForConnected = async () => {

        let param = {
            hostName: "",
            userName: "",
            passWord: "",
            dataBase: "",
            jobName: getValues().JOB_NAME,
            scheduleType: typeRunJob,
            scheduleDate: getSchedule(),
            scheduleHour: hourTime,
            scheduleTime: minuteTime,
            startDate: startDate,
            endDate: initDate === 1 ? addDays(endDate, lstInitScreen?.Effective_End ?? 0) : endDate,
            sqlScript: getValues().SCRIPT_TEXT,
            outPutType: typeOutput,
            notiEmail: state.checkedNotiEmail,
            listEmail: getValues().EMAIL_TEXT,
            endOfMonth: state.MONTHLY_DATE_END,
        };
        let res = await api.SaveJobSchedule(param);
        if (res.ResultCode === 10) { //Success
            alertDialog.SuccessShowButtonCloseModal("You Job Schedule setting completed.", props);
        }
        if (res.ResultCode === 20) {
            alertDialog.ErrorDialog(res?.Message);
            //setStep(0);
            return;
        }
    }
    const onCloseModal = async () => {
        let resConfirm = await alertDialog.ConfirmCommon("Do you want to close ?", "Yes", "No");
        if (!resConfirm) return;
        props.onClose();

    }
    const ValidateFormAdd = async () => {
        // alertDialog.SuccessShowButtonCloseModal("You Job Schedule setting completed.",props);
        //props.onClose();
        if (typeRunJob === 2 && listWeekly.length <= 0) { //check choose weekly
            alertDialog.ErrorDialog("Please Choose Day.");
            return;
        }
        // if (typeRunJob === 3 && listMonthly.length <= 0 && !state.MONTHLY_DATE_END) { //check choose monthly
        //     alertDialog.ErrorDialog("Please Choose Day.");
        //     return;
        // }
        if (typeRunJob === 3 && dayMonth === '') { //check choose monthly
            alertDialog.ErrorDialog("Please Choose Day.");
            return;
        }
        if (hourTime === '') { //check choose hour
            alertDialog.ErrorDialog("Please Choose Hour.");
            return;
        }
        if (minuteTime === '') { //check choose minute
            alertDialog.ErrorDialog("Please Choose Minute.");
            return;
        }
        if (getValues().JOB_NAME === '') { //check choose job name
            alertDialog.ErrorDialog("Please input Job Name.");
            return;
        }
        if (getValues().SCRIPT_TEXT === '') { //check choose sql
            alertDialog.ErrorDialog("Please input SQL Scipt.");
            return;
        }
        if (state.checkedNotiEmail && getValues().EMAIL_TEXT === '') {
            alertDialog.ErrorDialog("Please input Email.");
            return;
        }
        let valid = common.validateNotSpecialCharacter(getValues().JOB_NAME);
        if (!valid) { //check
            alertDialog.ErrorDialog("Job name not have special character.");
            return;
        }
        setStateScreen();
        console.log(step);
        let res = await api.CheckConnectDB();
        if (res.ResultCode === 10) { //Success
            SaveJobForConnected();
        }
        if (res.ResultCode === 20) {
            setStep(step + 1);
        }

    }
    const SaveJobSchedule = () => {
        if (step === 0) {
            ValidateFormAdd();
        } else if (step === 1) {
            SaveJob();
        }
    }
    const setStateScreen = () => {
        //console.log(getValues());
        setSqlText(getValues().SCRIPT_TEXT);
        setJobName(getValues().JOB_NAME);
        setEmailList(getValues().EMAIL_TEXT);

    }



    const PreviosForm = () => {
        //setStateScreen();
        setStep(step - 1);
    }
    const Form = () => {
        if (step === 0) {
            return (<AddEdit />);
        } else if (step === 1) {
            return (<ConnectSql />);
        }

    }

    const AddEdit = () => {

        return (
            <>
                <FormProvider {...method}>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.textLabelRight}>
                                        <InputLabel className={classes.textLabel}>Select Schedule Type : </InputLabel>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        {/* <InputLabel id="simple-select-outlined-label">Age</InputLabel> */}
                                        <Select
                                            labelId="simple-select-outlined-label"
                                            id="simple-select-outlined"
                                            name="TYPE_SCHEDULE"
                                            defaultValue={lstInitScreen?.ListScheduleType ? typeRunJob : ""}
                                            onChange={handleChange}

                                        >
                                            {lstInitScreen?.ListScheduleType?.map((item) => (
                                                <MenuItem key={item?.schedule_type_id} value={item.schedule_type_id}>{item?.schedule_type}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                            </Grid>
                            <Grid container spacing={2} hidden={hiddenMonthly}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.textLabelRight}>
                                        <InputLabel className={classes.textLabel}>Select Day : </InputLabel>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={4}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="simple-select-outlined-label">Day</InputLabel>
                                        <Select
                                            labelId="simple-select-outlined-label"
                                            id="simple-select-outlined"
                                            name="MONTHLY_DATE"
                                            label="Day"
                                            defaultValue={dayMonth ? dayMonth : ""}
                                            onChange={handleChangeMonthly}

                                        >
                                            {lstInitScreen?.ListMonthly?.map((item) => (
                                                <MenuItem key={item} value={item}>{item}</MenuItem>
                                            ))}
                                            <MenuItem key={txtEndOfmonth} value={txtEndOfmonth} >{txtEndOfmonth}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.textLabelRight}>
                                        <InputLabel className={classes.textLabel}>Select Time : </InputLabel>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="simple-select-outlined-label">Hour</InputLabel>
                                        <Select
                                            labelId="simple-select-outlined-label"
                                            id="simple-select-outlined"
                                            name="HOUR_TIME"
                                            defaultValue={lstInitScreen?.ListHourlyTime ? hourTime : ""}
                                            onChange={handleChangeHour}
                                            label="Hour"
                                        >
                                            {lstInitScreen?.ListHourlyTime?.map((item) => (
                                                <MenuItem key={item} value={item}>{item}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="simple-select-outlined-label">Minute</InputLabel>
                                        <Select
                                            labelId="simple-select-outlined-label"
                                            id="simple-select-outlined"
                                            name="MINUTE_TIME"
                                            defaultValue={lstInitScreen?.ListMinuteTime ? minuteTime : ""}
                                            onChange={handleChangeMinute}
                                            label="Minute"
                                        >
                                            {lstInitScreen?.ListMinuteTime?.map((item) => (
                                                <MenuItem key={item} value={item} disabled={listDisableTime.includes(item)}>{item}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.labelDate}>
                                        <InputLabel className={classes.textLabel}>Start Date : </InputLabel>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <MaterialUIDatePickers name="DATE_FROM" label="From" className={classes.formControl}
                                        format="dd-MMM-yyyy"
                                        variant="dialog"
                                        onChange={handleChangeStartDate}
                                        value={startDate}
                                        minDate={addDays(common.formatDate(new Date()), lstInitScreen?.Effective_Start ?? 0)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.labelDate}>
                                        <InputLabel className={classes.textLabel}>End Date : </InputLabel>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <MaterialUIDatePickers name="DATE_TO" label="To" className={classes.formControl}
                                        format="dd-MMM-yyyy"
                                        variant="dialog"
                                        onChange={handleChangeEndDate}
                                        value={initDate === 1 ? addDays(endDate, lstInitScreen?.Effective_End ?? 0) : endDate}
                                        minDate={addDays(startDate, lstInitScreen?.Effective_Start)}
                                        maxDate={addDays(startDate, lstInitScreen?.Effective_End)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={8}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    {lstInitScreen?.ListWeekly?.map((item, index) => (
                                        <FormControl key={index} variant="outlined" className={classes.checkWeekly} hidden={hiddenWeekly}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        onChange={handleChangeWeekly}
                                                        name="WEEKLY_DATE"
                                                        color="primary"
                                                        value={item}
                                                        inputRef={register}
                                                        defaultChecked={listWeekly.includes(item)}
                                                    />
                                                }
                                                label={item}
                                            />
                                        </FormControl>
                                    ))}
                                    {/* {lstInitScreen?.ListMonthly?.map((item, index) =>

                                        <FormControl key={index} variant="outlined" className={classes.checkWeekly} hidden={hiddenMonthly}>

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        //checked={item.values}
                                                        onChange={handleChangeMonthly}
                                                        name="MONTHLY_DATE"
                                                        color="primary"
                                                        value={item}
                                                        inputRef={register}
                                                        defaultChecked={listMonthly.includes(item)}
                                                    />
                                                }
                                                label={item}
                                            />
                                        </FormControl>
                                    )}
                                    <FormControl key="MONTH_END" variant="outlined" className={classes.checkWeekly} hidden={hiddenMonthly}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={state.MONTHLY_DATE_END}
                                                    onChange={handleChangeEndOFMonthly}
                                                    name="MONTHLY_DATE_END"
                                                    color="primary"

                                                />
                                            }
                                            label="End of Month"
                                        />
                                    </FormControl> */}
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item ls={4}>
                                <FormControl variant="outlined" className={classes.labelInput}>
                                    <InputLabel className={classes.textLabel}>Job Name : </InputLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} className={classes.textXS12}>
                                <TextField
                                    id="outlined-full-width"
                                    label=""
                                    name="JOB_NAME"
                                    inputRef={register}
                                    style={{ margin: 8 }}
                                    //placeholder="Placeholder"
                                    helperText="Fill out with English letters  only. The following special characters are not allowed ~ ! @ # $ % ^ * - _ = + [ { ] } / ; : , . ? Only _ (underscore ) is allowed"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    //rules={{ required: true, pattern: /^[a-zA-Z0-9_]*$/ }}
                                    variant={"outlined"}
                                    defaultValue={jobName}
                                    onChange={onInputJobChange}
                                    onBlurCapture={onCheckDulplicate}
                                    onKeyPress={(e) => {
                                        let valid = common.validateNotSpecialCharacter(e.key);
                                        if (!valid) {
                                            e.preventDefault();
                                            alertDialog.ErrorDialog("Job name not have special character.");
                                        }

                                    }}
                                    onPaste={(e) => {
                                        console.log(e.clipboardData.getData('Text'));
                                        let valid = common.validateNotSpecialCharacter(e.clipboardData.getData('Text'));
                                        if (!valid) {
                                            e.preventDefault();
                                            alertDialog.ErrorDialog("Job name not have special character.");
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item ls={4} >
                                <FormControl variant="outlined" className={classes.labelInputRadio}>
                                    <InputLabel className={classes.textLabel}>Input Type : </InputLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} className={classes.textXS12}>
                                <RadioGroup row aria-label="typeInputSql" name="typeInputSql" value={typeInputSql} onChange={handleChangeTypeSql}
                                >
                                    <FormControlLabel value="TextFile" control={<Radio />} label="Text File" />
                                    <FormControlLabel value="FreeText" control={<Radio />} label="Free Text" />


                                </RadioGroup>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item ls={2}>
                                <FormControl variant="outlined" className={classes.labelInput}>
                                    <InputLabel className={classes.textLabel}>Script : </InputLabel>
                                </FormControl>
                            </Grid>

                            <Grid item xs={8} className={classes.textXS12}>
                                <FormControl variant="outlined" className={classes.textLabelRight} hidden={hiddenUpfile} fullWidth={true}>
                                    <Box display="flex" className="browseFile">
                                        <TextField
                                            disabled
                                            id="outlined-full-width"
                                            label=""
                                            fullWidth
                                            name="FILE_NAME"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="outlined"
                                            value={file?.name || ""}
                                        />
                                        <button onClick={(e) => hiddenFileInput.current.click()}>Browse</button>
                                        {/* <button onClick={openModalUpload}>Browse</button> */}
                                        <input type="file" name="file" ref={hiddenFileInput} onChange={onFileChange} accept=".txt, .sql" style={{ display: 'none' }} />
                                    </Box>


                                </FormControl>
                                <FormControl variant="outlined" className={classes.textLabelRight} hidden={hiddenFreeText} fullWidth={true}>
                                    <TextField
                                        id="outlined-full-width"
                                        label=""
                                        style={{ margin: 8 }}
                                        multiline
                                        rows={10}
                                        fullWidth
                                        name="SCRIPT_TEXT"
                                        onChange={onSQLChange}
                                        // onPaste={(e)=>{
                                        //     console.log(e.target.value);

                                        //     if (getValues().SCRIPT_TEXT.length > limitLengthSql) {
                                        //         e.preventDefault();
                                        //         alertDialog.ErrorDialog(txtErrorLength);
                                        //     }
                                        // }}
                                        margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputProps={{
                                            maxLength: limitLengthSql,
                                        }}
                                        inputRef={register}
                                        variant="outlined"
                                        defaultValue={sqlText}
                                    />

                                </FormControl>

                                <DropzoneDialog
                                    acceptedFiles={[".txt, .sql"]}
                                    cancelButtonText={"cancel"}
                                    filesLimit={1}
                                    submitButtonText={"submit"}
                                    maxFileSize={16777216}
                                    open={openUpload}
                                    onClose={() => setOpenUpload(false)}
                                    onSave={(files) => {
                                        upload(files);
                                        setOpenUpload(false);
                                    }}
                                    showPreviews={false}
                                    showFileNamesInPreview={false}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item ls={2}>
                                <FormControl variant="outlined" className={classes.labelInputRadio}>
                                    <InputLabel className={classes.textLabel}> </InputLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4} className={classes.textXS12}>

                                <InputLabel className={classes.textLabelCountLength} hidden={hiddenFreeText}><div id="countLenght">{genDivCountSql(sqlText?.length)}</div></InputLabel>
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item ls={2}>
                                <FormControl variant="outlined" className={classes.labelInputRadio}>
                                    <InputLabel className={classes.textLabel}>Output Type : </InputLabel>
                                </FormControl>
                                <InputLabel className={classes.textLabelHelper}>(If Need)</InputLabel>
                            </Grid>
                            <Grid item xs={8} className={classes.textXS12}>
                                <RadioGroup row aria-label="typeOutput" name="TYPE_OUTPUT" value={typeOutput}
                                >
                                    {/* <FormControlLabel value="" control={<Radio />} label="None" /> */}
                                    <FormControlLabel value="CSV" control={<Radio onClick={handleChangeOutputType} />} label="CSV" />
                                    <FormControlLabel value="Text" control={<Radio onClick={handleChangeOutputType} />} label="Text" />
                                </RadioGroup>
                                <InputLabel className={classes.textOutputHelper}> * The file is automatically saved as text file , In case you want to save as a different file , please select it</InputLabel>

                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item ls={4}>
                                <FormControl variant="outlined" className={classes.labelInputCheckBox}>
                                    <InputLabel className={classes.textLabel}>Notification by Email : </InputLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} className={classes.textXS12Mail}>
                                <FormControl variant="outlined" className={classes.textInput}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={state.checkedNotiEmail}
                                                onChange={handleChangeNotiMail}
                                                name="checkedNotiEmail"
                                                color="primary"

                                            />
                                        }
                                        label="Yes"
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item ls={2}>
                                <FormControl variant="outlined" className={classes.labelInput}>
                                    <InputLabel className={classes.textLabel}> </InputLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    id="outlined-full-width"
                                    label=""
                                    style={{ margin: 8 }}
                                    multiline
                                    rows={10}
                                    fullWidth
                                    inputRef={register}
                                    name="EMAIL_TEXT"
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    defaultValue={emailList}
                                    hidden={hiddenInputMail}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>

            </>
        );
    }
    const ConnectSql = () => {
        return (
            <>
                <Grid item xs={12} >
                    <Grid item xs={3}> </Grid>
                    <Grid item xs={6} className={classes.alignConnect}>
                        {/* <Box m={3} maxWidth="500px" flexGrow={1}>
                            <TextField
                                id="HostName-textarea"
                                name="HostName"
                                inputRef={register}
                                label="HostName "
                                placeholder=""
                                variant="filled"
                                onChange={ClearError}
                                rows={1}
                                fullWidth
                                InputProps={{
                                    readOnly: true,
                                }}
                                defaultValue={lstInitScreen?.DBInformation != null ? lstInitScreen?.DBInformation?.hostName : ""}
                                error={errors?.hasOwnProperty("HostName")}
                                helperText={errors?.["HostName"]?.message || ''}
                            />
                        </Box> */}
                        <Box m={3} maxWidth="500px" flexGrow={1}>
                            <FormControl fullWidth>
                            <InputLabel id="simple-select-outlined-label">HostName</InputLabel>
                                <Select
                                    labelId="simple-select-outlined-label"
                                    id="HostName-textarea"
                                    name="HostName"
                                    label="HostName "
                                    variant="filled"
                                    fullWidth
                                    inputRef={register}
                                    value={hostKey === "" ? lstInitScreen?.DBInformation?.hostKey : hostKey}
                                    onChange={handleChangeHostName}

                                >
                                    {lstInitScreen?.ListDataBase?.map((item) => (
                                        <MenuItem key={item?.HOST_KEY} value={item?.HOST_KEY}>{item?.HOST_TITLE}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        <Box m={3} maxWidth="500px" flexGrow={1}>
                            <TextField
                                id="UserName-textarea"
                                name="UserName"
                                inputRef={register}
                                label="UserName "
                                placeholder=""
                                //onChange={ClearError}
                                multiline
                                variant="outlined"
                                rows={1}
                                fullWidth
                            //defaultValue={userName}
                            // error={errors?.hasOwnProperty("UserName")}
                            //helperText={errors?.["UserName"]?.message || ''}
                            />
                        </Box>
                        <Box m={3} maxWidth="500px" flexGrow={1}>
                            <TextField
                                id="Password-textarea"
                                name="Password"
                                label="Password"
                                inputRef={register}
                                type="password"
                                variant="outlined"
                                rows={1}
                                fullWidth
                            //defaultValue={passWord}
                            //defaultValue={connectInfo?.Result != null ? connectInfo?.Result?.passWord : ""}
                            // error={errors && errors.hasOwnProperty("Password")}
                            // helperText={errors && errors["Password"] || ''}
                            />
                        </Box>
                        <Box m={3} maxWidth="500px" flexGrow={1}>
                            <TextField
                                id="Database-textarea"
                                name="Database"
                                inputRef={register}
                                label="Database "
                                placeholder=""
                                multiline
                                variant="filled"
                                rows={1}
                                fullWidth
                                InputProps={{
                                    readOnly: true,
                                }}
                                //defaultValue={lstInitScreen?.DBInformation != null ? lstInitScreen?.DBInformation?.dataBase : ""}
                                //onKeyDown={handleEnter}
                                value={dbName === "" ? lstInitScreen?.DBInformation?.dataBase : dbName}
                                error={errors && errors.hasOwnProperty("Database")}
                                helperText={errors?.["Database"]?.message || ''}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={3}> </Grid>
                </Grid>
            </>
        );
    }
    return (
        <Modal
            {...otherprops}
            onNext={SaveJobSchedule} NextText="Submit"
            //onPrev={PreviosForm}
            //onClose={onCloseModal}
            disableBackdropClick={true}
            hiddenPrev={true}
            onClose={step === 0 ? onCloseModal : PreviosForm}
            CloseText="Cancel"
            //hiddenPrev={step === 0 ? true : false}
            title="Add Job Schedule"
            maxWidth='lg'


        >
            <Form />
        </Modal>
    );

}


export default AddJobSchedule;
